import { AlgoliaIndiceName } from '@packages/common';
import { LatLong } from '@packages/common';

import { SearchBase } from './searchBase';

const attributesToRetrieve = ['postalCode'];

export const branchStoresSearch = (searchBase: SearchBase) => (coords: LatLong) => {
  return searchBase<{ postalCode: string }>(AlgoliaIndiceName.BRANCH_STORES, {
    attributesToRetrieve,
    hitsPerPage: 1000,
    aroundLatLng: `${coords.lat}, ${coords.lng}`,
    aroundRadius: 50000,
  });
};
